/**
 * Auto-submit datumfilter: båda fält, båda tomma, eller ett fält när sidan redan hade datumfilter.
 */
export function shouldAutoSubmitEventDateFilter(franValue, tillValue, pageHadDateFilter = false) {
    const fran = (franValue || '').trim();
    const till = (tillValue || '').trim();
    if (fran !== '' && till !== '') {
        return true;
    }
    if (fran === '' && till === '') {
        return true;
    }
    if (pageHadDateFilter) {
        return true;
    }

    return false;
}

export function submitEventFilterForm(form) {
    if (!form) {
        return;
    }
    if (typeof form.requestSubmit === 'function') {
        try {
            form.requestSubmit();
            return;
        } catch (err) {
            // Saknas i jsdom eller äldre webbläsare — fall back nedan.
        }
    }
    form.submit();
}
